import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as api from "../../../common/manipurCommon/API";
import * as func from "../../../common/manipurCommon/FunctionCalls";
import ImageWithBasePath from "../../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Select from "react-select";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";
import Utils from "../../../common/manipurCommon/Utils";

const HPCSchedules = () => {

    const [scheduleList, setScheduleList] = useState<any[]>([]);
    const [batchList, setBatchList] = useState<any[]>([]);
    const [scheduleTypeList, setScheduleTypeList] = useState<any[]>([]);
    const [skillList, setSkillList] = useState<any[]>([]);
    const [geoList, setGeoList] = useState<any[]>([]);
    const [hpcList, setHpcList] = useState<any[]>([]);
    const [scheduleId, setScheduleId] = useState("");
    const [scheduleTypeId, setScheduleTypeId] = useState("");
    const [batchId, setBatchId] = useState("");
    const [skillId, setSkillId] = useState([]);
    const [scdlDate, setScdlDate] = useState([]);
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [comment, setComment] = useState("");
    const [scdlStatus, setScdlStatus] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [currentDate, setCurrentDate] = useState("");
    const [geoId, setGeoId] = useState("");
    const [hpcId, setHpcId] = useState("");
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [orderedSkills, setOrderedSkills] = useState([]);
    const [selectedDates, setSelectedDates] = useState([]);
    const [dropdowns, setDropdowns] = useState([]);
    const [scheduleDate, setScheduleDate] = useState([]);
    const [previousScheduleDate, setPreviousScheduleDate] = useState(null);
    const [previousSkill, setPreviousSkill] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchSchedules() {
            setIsLoading(true);
            const scheduleResponse = await func.hpcSchedule(null);
            setScheduleList(Array.isArray(scheduleResponse) ? scheduleResponse : [])
            setIsLoading(false);
        }
        fetchSchedules();
    }, [])

    const filteredData = scheduleList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const batchNameRender = (rowData) => {
        return <span>{rowData.batchName}</span>
    }

    const skillNameRender = (rowData) => {
        return <span>{rowData.skillName}</span>
    }

    const scheduleDateRender = (rowData) => {
        return <span>{formatDate(rowData.scheduleDate)}</span>
    }

    const startTimeRender = (rowData) => {
        return <span>{rowData.scheduleStartTime}</span>
    }

    const endTimeRender = (rowData) => {
        return <span>{rowData.scheduleEndTime}</span>
    }

    const scheduleStatusRender = (rowData) => {
        return <span>{(rowData.scheduleStatus == 1) ? "Active" : "Inactive"}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editSchedule(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const scdlId = rowData.scheduleId;
        return (
            <Link to="#" onClick={() => deleteSchedule(scdlId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const clearAllDates = () => {
        setDropdowns([]);
        setScdlDate([]);
        setSelectedDates([]);
        setSelectedOptions([]);
    }

    const handleSelectedSkill = (dropdownId) => (selectedOption) => {
        if (selectedOption) {
            setSelectedOptions((prevValues) => {
                const prevSkill = prevValues[dropdownId];
                const updatedValues = {
                    ...prevValues,
                    [dropdownId]: selectedOption.value,
                };

                // Step 1: Keep existing order as much as possible (duplicates allowed)
                const newOrdered = [];
                orderedSkills.forEach((skill) => {
                    if (Object.values(updatedValues).includes(skill)) {
                        newOrdered.push(skill); // No Set check — duplicates allowed
                    }
                });

                // Step 2: Append any newly selected skills (still allowing duplicates)
                Object.values(updatedValues).forEach((skill) => {
                    if (!newOrdered.includes(skill) ||
                        newOrdered.filter(s => s === skill).length <
                        Object.values(updatedValues).filter(s => s === skill).length) {
                        newOrdered.push(skill);
                    }
                });

                // Reverse map: skill -> dropdownId (based on updatedValues)
                const skillToDropdownMap = {};
                for (const [key, value] of Object.entries(updatedValues)) {
                    // Store multiple IDs for the same skill
                    if (!skillToDropdownMap[value]) {
                        skillToDropdownMap[value] = [];
                    }
                    skillToDropdownMap[value].push(key);
                }

                // Rebuild selectedOptions (duplicates allowed)
                const rebuiltSelectedOptions = {};
                const usedIds = new Set();
                newOrdered.forEach((skill) => {
                    const ids = skillToDropdownMap[skill] || [];
                    const nextId = ids.find(id => !usedIds.has(id));
                    if (nextId) {
                        rebuiltSelectedOptions[nextId] = skill;
                        usedIds.add(nextId);
                    }
                });

                setOrderedSkills(newOrdered);

                if (newOrdered.length > 1) {
                    setPreviousSkill(newOrdered[newOrdered.length - 2]);
                }

                return rebuiltSelectedOptions;
            });
        }
    };

    const handleDateChange = (e) => {
        const newDate = e.target.value;
        if (newDate) {
            setSelectedDates(prevDates => {
                if (prevDates.length > 0) {
                    setPreviousScheduleDate(prevDates[prevDates.length - 1]);
                    addDropdown(prevDates[prevDates.length - 1]); // Add a dropdown with the previous date
                }

                if (scheduleId != 3) {
                    // else{
                    const updatedDates = [...prevDates, newDate];
                    addDropdown(newDate); // Add a dropdown with the new date
                    return updatedDates;
                }
            });
            setCurrentDate(newDate);
        }
    };

    const removeDropdown = (id) => {
        // Find the dropdown to remove from the current state
        const dropdownToRemove = dropdowns.find((dropdown) => dropdown.id === id);
        if (!dropdownToRemove) return;

        // Remove it from dropdown list
        setDropdowns((prevDropdowns) => prevDropdowns.filter((dropdown) => dropdown.id !== id));

        // Remove corresponding date
        setSelectedDates((prevDates) =>
            prevDates.filter((date) => date !== dropdownToRemove.date)
        );
    };

    const addDropdown = (date) => {
        const getSkillSet = api.GetSkillsByGeoandBatch + '/' + hpcId + "/" + batchId;
        fetch(getSkillSet, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((sklResponse) => sklResponse.json())
            .then((sklResult) => {
                if (sklResult.code == 401) {
                    Utils.logoutUser();
                }
                if (sklResult.error == true) {
                    Swal.fire(sklResult.message)
                }
                else {
                    if (sklResult.data) {
                        const newOptions = sklResult.data.map((item) => ({
                            value: item.skillId,
                            label: item.skillName,
                        }));
                        const id = dropdowns.length + new Date().getTime();
                        setDropdowns([
                            ...dropdowns,
                            {
                                id: dropdowns.length + new Date().getTime(),
                                date: date, // Store the date associated with this dropdown
                                options: newOptions,
                            },
                        ]);
                        // Set the selected option using scheduleSkillId
                        setSelectedOptions({
                            [id]: skillId
                        });

                        setScheduleDate([date]);
                    }
                }
            })
            .catch((error) => {
                console.log('Failed to get skill list', error);
            })
    }

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    async function newSchedule() {
        setIsEdit(false)
        setOpenModal(true)
        setBatchId("")
        setSkillId([])
        setScdlDate("")
        setStartTime("")
        setEndTime("")
        setComment("")
        const geoResponse = await func.listGeoStates();
        setGeoList(Array.isArray(geoResponse) ? geoResponse : [])
        const btchResponse = await func.hpcBatch(null);
        setBatchList(Array.isArray(btchResponse) ? btchResponse : [])
        const skillResponse = await func.skills(null);
        setSkillList(Array.isArray(skillResponse) ? skillResponse : [])
        const scdlTypResponse = await func.scheduleType(null);
        setScheduleTypeList(Array.isArray(scdlTypResponse) ? scdlTypResponse : [])
    }

    async function editSchedule(rowData: { scheduleId: string | number; }) {
        const scdlId = rowData.scheduleId;
        setIsEdit(true)
        setOpenModal(true)
        const btchResponse = await func.hpcBatch(null);
        setBatchList(Array.isArray(btchResponse) ? btchResponse : [])
        const skillResponse = await func.skills(null);
        setSkillList(Array.isArray(skillResponse) ? skillResponse : [])
        const scdlTypResponse = await func.scheduleType(null);
        setScheduleTypeList(Array.isArray(scdlTypResponse) ? scdlTypResponse : [])
        const getDetails = await func.hpcSchedule(scdlId);
        setScheduleId(getDetails.scheduleId)
        setScheduleTypeId(getDetails.scheduleTypeId)
        setBatchId(getDetails.scheduleHpcBatchId)
        setSkillId(getDetails.scheduleSkillId)
        setScdlDate(getDetails.scheduleDate)
        setStartTime(getDetails.scheduleStartTime)
        setEndTime(getDetails.scheduleEndTime)
        setComment(getDetails.scheduleComments)
        setScdlStatus(getDetails.scheduleStatus)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateSchdule();
            } else {
                const selectedValues = Object.values(selectedOptions);
                const selectedDateValues = Object.values(selectedDates);
                const skillArray = selectedValues.map((value, index) => ({
                    skill: value,
                    date: selectedDateValues[index],
                }));
                const formData = new FormData();
                formData.append("batchId", batchId);
                formData.append("skillId", JSON.stringify(skillArray));
                formData.append("scheduleTypeId", scheduleTypeId);
                formData.append("date", JSON.stringify(selectedDateValues));
                formData.append("start", startTime);
                formData.append("end", endTime);
                formData.append("comment", comment);

                const createScdl = api.HPCSchedules;
                fetch(createScdl, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }
    }

    function updateSchdule() {
        const formData = new FormData();
        formData.append("batchId", batchId);
        formData.append("skillId", JSON.stringify([Number(skillId)]));
        formData.append("scheduleTypeId", scheduleTypeId);
        formData.append("date", scdlDate);
        formData.append("start", startTime);
        formData.append("end", endTime);
        formData.append("comment", comment);
        formData.append("status", scdlStatus);

        const updateScdl = api.HPCSchedules + "/" + scheduleId;
        fetch(updateScdl, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteSchedule(scdlId: string) {
        const delteScdl = api.HPCSchedules + "/" + scdlId + '/' + 0;
        fetch(delteScdl, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Schedules</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newSchedule() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Schedule">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="batchName"
                                                header="Batch Name"
                                                body={batchNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="skillName"
                                                header="Skill Name"
                                                body={skillNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="scheduleDate"
                                                header="Schedule Date"
                                                body={scheduleDateRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="scheduleStartTime"
                                                header="Start Time"
                                                body={startTimeRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="scheduleEndTime"
                                                header="End Time"
                                                body={endTimeRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="scheduleStatus"
                                                header="Schedule Status"
                                                body={scheduleStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {openModal && (
                <Modal
                    show={openModal}
                    size="xl"
                    scrollable
                    centered>
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Schedule</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody style={{ maxHeight: "750px" }}>
                        <form ref={formRef}>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="row">
                                        <div className="col-lg-6 mb-10">
                                            <div className="input-space">
                                                <label className="form-label">Geography</label>
                                                <Select
                                                    value={geoList.find(state => state.geographyId === geoId) ? {
                                                        value: geoId,
                                                        label: geoList.find(state => state.geographyId === geoId).geographyName
                                                    } : null}
                                                    onChange={async (e) => {
                                                        setGeoId(e.value);
                                                        const hpcResponse = await func.getHpcByGeography(e.value);
                                                        setHpcList(Array.isArray(hpcResponse) ? hpcResponse : [])
                                                    }}
                                                    required
                                                    styles={customSelect}
                                                    placeholder="Select State"
                                                    options={geoList.map(state => ({
                                                        value: state.geographyId,
                                                        label: state.geographyName
                                                    }))}>
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mb-10">
                                            <div className="input-space">
                                                <label className="form-label">Center</label>
                                                <Select
                                                    value={hpcList.find(hpc => hpc.geoHPCId === hpcId) ? {
                                                        value: hpcId,
                                                        label: hpcList.find(hpc => hpc.geoHPCId === hpcId).geoHPCName
                                                    } : null}
                                                    onChange={async (e) => {
                                                        setHpcId(e.value);
                                                        const btchResponse = await func.getBatchByHpc(e.value);
                                                        setBatchList(Array.isArray(btchResponse) ? btchResponse : [])
                                                    }}
                                                    required
                                                    styles={customSelect}
                                                    placeholder="Select Center"
                                                    options={hpcList.map(hpc => ({
                                                        value: hpc.geoHPCId,
                                                        label: hpc.geoHPCName
                                                    }))}>
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mb-10">
                                            <div className="input-space">
                                                <label className="form-label">Batch Name</label>
                                                <Select
                                                    value={batchList.find(btch => btch.batchId === batchId) ? {
                                                        value: batchId,
                                                        label: batchList.find(btch => btch.batchId === batchId).batchName
                                                    } : null}
                                                    onChange={async (e) => {
                                                        setBatchId(e.value);
                                                    }}
                                                    required
                                                    styles={customSelect}
                                                    placeholder="Select Batch"
                                                    options={batchList.map(btch => ({
                                                        value: btch.batchId,
                                                        label: btch.batchName
                                                    }))}>
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mb-10">
                                            <div className="input-space">
                                                <label className="form-label">Schedule Type</label>
                                                <Select
                                                    value={scheduleTypeList.find(scdl => scdl.schedulesId === scheduleTypeId) ? {
                                                        value: scheduleTypeId,
                                                        label: scheduleTypeList.find(scdl => scdl.schedulesId === scheduleTypeId).schedulesName
                                                    } : null}
                                                    onChange={async (e) => {
                                                        setScheduleTypeId(e.value);
                                                    }}
                                                    required
                                                    styles={customSelect}
                                                    placeholder="Select Schedule Type"
                                                    options={scheduleTypeList.map(scdl => ({
                                                        value: scdl.schedulesId,
                                                        label: scdl.schedulesName
                                                    }))}>
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 mb-10">
                                            <div className="input-space">
                                                <label className="form-label">Schedule Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    id="currentDate"
                                                    placeholder="Select Date"
                                                    required
                                                    value={currentDate}
                                                    // onChange={(e) => setScdlDate(e.target.value)}
                                                    onChange={handleDateChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-10">
                                            <div className="col d-flex justify-content-between">
                                                <div className="col-lg-5">
                                                    <label className="form-label">Start Time</label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        id="startTime"
                                                        placeholder="Start Time"
                                                        required
                                                        value={startTime}
                                                        onChange={(e) => setStartTime(e.target.value)}
                                                    />
                                                </div>
                                                <div className="col-lg-5">
                                                    <label className="form-label">End Time</label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        id="startTime"
                                                        placeholder="Start Time"
                                                        required
                                                        value={endTime}
                                                        onChange={(e) => setEndTime(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mb-10">
                                            <div className="input-space">
                                                <label className="form-label">Schedule Comment</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="ScdlCmnt"
                                                    placeholder="Schedule Comment"
                                                    value={comment}
                                                    onChange={(e) => setComment(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        {isEdit ?
                                            <>
                                                <div className="row">
                                                    <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                        <label className="form-label">Status</label>
                                                    </div>
                                                    <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                        <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                            <input
                                                                className="form-check-input text-end"
                                                                type="checkbox"
                                                                checked={scdlStatus === '1'}
                                                                id="scdlStatus"
                                                                onChange={(e) => {
                                                                    setScdlStatus(e.target.checked ? '1' : '0')
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </> : null
                                        }
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="card-title">
                                                Select Skills For Dates
                                            </div>
                                        </div>
                                        <div className="col-md-6 text-end">
                                            <a href="#" onClick={clearAllDates}><span>X</span><u>Clear all Data</u></a>
                                        </div>
                                    </div>
                                    {dropdowns.map((dropdown) => (
                                        <div className="mb-10" key={dropdown.id}>
                                            <div className="info d-lg-flex justify-content-between">
                                                <label className="sortbytitle"><h6>{formatDate(dropdown.date)}</h6></label>
                                                <a href="#" onClick={(e) => {
                                                    e.preventDefault();
                                                    removeDropdown(dropdown.id);
                                                }}><span>X</span><u>Remove</u></a>
                                            </div>
                                            <Select
                                                key={dropdown.id}
                                                // value={selectedOptions[dropdown.id] || null}
                                                value={dropdown.options.find(option => option.value === selectedOptions[dropdown.id]) || null}
                                                options={dropdown.options}
                                                styles={customSelect}
                                                required
                                                onChange={handleSelectedSkill(dropdown.id)}
                                                className="dropdown" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <ModalFooter>
                                <Button
                                    className="btn-primary text-uppercase"
                                    variant="success"
                                    type="submit"
                                    onClick={handleSubmit}
                                >
                                    <b><i className="fas fa-save" />Save</b>
                                </Button>
                            </ModalFooter>
                        </form>
                    </ModalBody>
                </Modal>
            )}
        </>
    )
};

export default HPCSchedules;